import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITagsParams } from '../../../ts/ServerApi/types/actionParams';

export class AddTagsToWorkbooksRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToWorkbooks', {
      ids: ids,
      tags: tags
    });
  }
}
